'use client';

import React from 'react';

import { CurrencyIcon } from '@/blocks/components/AssetIcon';
import { AssetsCarousel } from '@/blocks/components/AssetsCarousel';
import { CurrencyBadge } from '@/blocks/components/CurrencyBadge';
import { LinkConverters } from '@/blocks/components/LinkConverters';
import { FormatAssetName } from '@/blocks/formatters';

import { CurrencyPairs } from '@/app/[lang]/converters/types';

export function ConvertersBaseConversionsCarousel({ assets }: { assets: CurrencyPairs[] }) {
  const row1 = assets.slice(0, Math.ceil(assets.length / 2));
  const row2 = assets.slice(Math.ceil(assets.length / 2));

  function renderAsset(pair: CurrencyPairs) {
    const [from, to] = pair.pair.split('/');
    return (
      <LinkConverters from={from} to={to} data-event-label={pair.pair}>
        <CurrencyBadge
          text={<FormatAssetName assetName={pair.pair} />}
          icon={<CurrencyIcon currencyName={pair.icon} />}
        />
      </LinkConverters>
    );
  }

  return (
    <AssetsCarousel>
      <AssetsCarousel.Row items={row1} renderItem={renderAsset} />
      <AssetsCarousel.Row items={row2} renderItem={renderAsset} dir={'left'} />
    </AssetsCarousel>
  );
}
